import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTitre } from "@shared/hooks/useTitre";
import { useAuth } from "./AuthContext";

export function PageConnexion() {
  useTitre("Connexion");
  const { connexion } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [motDePasse, setMotDePasse] = useState("");
  const [erreur, setErreur] = useState<string | null>(null);
  const [envoi, setEnvoi] = useState(false);

  async function soumettre() {
    setErreur(null); setEnvoi(true);
    try {
      await connexion(email, motDePasse);
      navigate("/recherche");
    } catch {
      // message identique quel que soit l'échec : pas d'énumération de comptes
      setErreur("Identifiants incorrects. Vérifiez l'adresse et le mot de passe.");
    } finally { setEnvoi(false); }
  }

  return (
    <main className="connexion">
      <div className="panel" style={{ maxWidth: 380, margin: "80px auto" }}>
        <h1 className="marque">scraping<b>-for-</b>sales</h1>
        <label className="f" htmlFor="email">Adresse e-mail</label>
        <input id="email" type="email" value={email} autoComplete="username"
               onChange={e => setEmail(e.target.value)}
               onKeyDown={e => e.key === "Enter" && soumettre()} />
        <label className="f" htmlFor="mdp" style={{ marginTop: 12 }}>Mot de passe</label>
        <input id="mdp" type="password" value={motDePasse} autoComplete="current-password"
               onChange={e => setMotDePasse(e.target.value)}
               onKeyDown={e => e.key === "Enter" && soumettre()} />
        {erreur && <p className="erreur" style={{ marginTop: 12 }}>{erreur}</p>}
        <button className="btn" style={{ marginTop: 16, width: "100%" }} onClick={soumettre} disabled={envoi}>
          {envoi ? "Connexion…" : "Se connecter"}
        </button>
      </div>
    </main>
  );
}
